import "swiper/css";
import "swiper/css/pagination";
import "./Slider.scss"

import React, { FC, useContext, useEffect, useState } from "react"

import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper";
import NavContext from '../Layout/Nav/NavProvider';

type SliderProps = {
  children?: any;
  hidePagination?: boolean;

}

const Slider: FC<SliderProps> = ({ children, hidePagination }: SliderProps) => {
  const { setActiveSlide, currentSlide, setCurrentSlide, isMobile } = useContext(NavContext);

  const [isMobileActive, setIsMobileActive] = useState<boolean>(false);
  const [swiperObject, setSwiperObject] = useState(null);

  const slidesWithScrollable = {};
  let touchY;

  const enableSwipe = (swiper, isEnabled: boolean) => {
    if (!swiper.mousewheel) {
      return;
    }
    if (isEnabled) {
      swiper.mousewheel.enable();
    } else {
      swiper.mousewheel.disable();
    }
    swiper.allowTouchMove = isEnabled;
    swiper.allowSlideNext = isEnabled;
    swiper.allowSlidePrev = isEnabled;
  };

  const scrollingHandler = (swiper) => {
    const activeIndex = swiper.activeIndex;
    if (!slidesWithScrollable[activeIndex]) {
      return;
    }

    const elScrollable = slidesWithScrollable[activeIndex];

    const checkScrollIsFinished = (event) => {
      let direction = 'down';
     
      if (
        (event.deltaY && event.deltaY < 0)
        || (event.touches && event.touches[0].clientY >= touchY)
      ) {
        direction = 'up';
      }

      const scrollTopReached = direction === 'up' && elScrollable.scrollTop === 0;
      const scrollCompleted = Math.ceil(elScrollable.scrollTop + elScrollable.offsetHeight + 10);
      const scrollBottomReached = direction === 'down' && scrollCompleted >= Math.ceil(elScrollable.scrollHeight);

      return scrollTopReached || scrollBottomReached;
    };

    const scrollingInside = (event) => {
      enableSwipe(swiper, false);

      let clientX;
      let clientY;

      if (event.touches) {
        clientY = event.touches[0].clientY;
        clientX = event.touches[0].clientX;
      } else {
        clientY = event.clientY;
        clientX = event.clientX;
      }

      const elScrollableCR = (elScrollable as HTMLDivElement).getBoundingClientRect();
      const { top, right, bottom, left } = elScrollableCR;

      
      if ((clientY >= top && clientY <= bottom) && (clientX >= left && clientX <= right)) {
        if (checkScrollIsFinished(event)) {
            enableSwipe(swiper, true);
            return;
        }
        return;
      }

      enableSwipe(swiper, true);
    }

    window.addEventListener("wheel", scrollingInside, true);
    window.addEventListener("touchmove", scrollingInside, true);
    window.addEventListener("touchstart", (event) => {
      touchY = event.touches[0].clientY;
    }, true);
  };

  const swiperPlugin = ({ on }) => {
    on('afterInit', (swiper) => {
      swiper.pagination.bullets.forEach((bullet) => {
        bullet.addEventListener('click', () => {
          enableSwipe(swiper, true);
        });
      });

      swiper.slides.forEach((slide, index) => {
        slidesWithScrollable[index] = slide.querySelector('.scrollable');
      });

      scrollingHandler(swiper);
    });

    on('slideChangeTransitionEnd', scrollingHandler);
  };

  const slideToTop = (swiper) => {
    if (!swiperObject) {
      setSwiperObject(swiper);
    }
    setActiveSlide(swiper.activeIndex);
  }

  useEffect(() => {
    setIsMobileActive(isMobile());
  }, [isMobile])

  useEffect(() => {
    if (swiperObject && currentSlide === 0) {
      swiperObject.slideTo(0);
      setCurrentSlide(null);
    }
  }, [currentSlide])

  return (
    <Swiper
      speed={1200}
      direction={'vertical'}
      slidesPerView={1}
      spaceBetween={0}
      watchOverflow
      onSlideChange={(swiper) => slideToTop(swiper)}
      threshold={0}
      followFinger={isMobileActive ? false : true}
      lazy={true}
      mousewheel={{
        forceToAxis: true,
        sensitivity: 0,
        thresholdTime: 200,
        thresholdDelta: 50
      }}
      pagination={ hidePagination ? false : {
        clickable: true,
        bulletElement: 'a'
      }}
      modules={[Mousewheel, Pagination, swiperPlugin]}
      className="youplanet-page-slides"
    >
    {
      (children as React.ReactNode[]).map((child, index) => {
        return  (
          <SwiperSlide key={`slide-${index}`}>{child}</SwiperSlide>
        )
      })
    }
    </Swiper>
  )
}

export default Slider
